import workpackRoutes from '@/components/workpacks/routes';
import { Equipment } from '@/components';
import Inspection from './InspectionContainer.vue';
import { DeckPlan } from './components';

export default (beforeEnter) => ({
  path: '/inspection',
  name: 'Inspection',
  component: Inspection,
  beforeEnter,
  children: [
    {
      path: 'equipment',
      name: 'equipment',
      component: Equipment,
      meta: {
        breadcrumb() {
          return {
            getters: ['config/projectNameAndDate'],
            parents: ['home', 'Inspection'],
          };
        },
      },
    },
    {
      path: 'deckplans',
      name: 'deckplans',
      component: DeckPlan,
      meta: {
        breadcrumb() {
          return {
            getters: ['config/projectNameAndDate'],
            parents: ['home', 'Inspection'],
          };
        },
      },
    },
    ...workpackRoutes,
    {
      path: '/*',
      redirect: 'equipment',
    },
  ],
});
